import { render } from "./ButtonDownloadFileComponent.vue?vue&type=template&id=325c3ac2&scoped=true"
import script from "./ButtonDownloadFileComponent.vue?vue&type=script&lang=js"
export * from "./ButtonDownloadFileComponent.vue?vue&type=script&lang=js"

import "./ButtonDownloadFileComponent.vue?vue&type=style&index=0&id=325c3ac2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325c3ac2"]])

export default __exports__